import React from "react";
import styled from "styled-components";

export function Card({ header, summary, subHeader }) {
  let subHeaderText = subHeader;
  return (
    <CardLayout>
      <HeaderLayout>
        <Header>
          {header}
          <SubHeader>{subHeaderText}</SubHeader>
        </Header>
      </HeaderLayout>
      <SummaryText>{summary}</SummaryText>
    </CardLayout>
  );
}
const HeaderLayout = styled.div`
  display: flex;
`;
const Header = styled.div`
  font-size: 24px;
  @media (max-width: 750px) {
    font-size: 16px;
  }
`;
const SubHeader = styled.span`
  margin-left: 50px;
  font-size: 16px;
  @media (max-width: 750px) {
    font-size: 11px;
  }
`;
const CardLayout = styled.div`
  margin: 25px;
  padding: 15px;
  @media (max-width: 750px) {
    margin: 10px;
    padding: 5px;
  }
  border: 1px solid #5181ac;
`;
const SummaryText = styled.div`
  text-align: left;
  width: 100%;
  @media (max-width: 750px) {
    font-size: 10px;
    overflow: hidden;
  }
`;
export const SummaryPanel = styled.div``;
